import React from 'react'

import { StyledChoseEntityButton } from './entityChoice.styled';
import { ChoseEntityLabel } from '@bit/wavfichacerta.fichacerta.shared-styles.typography';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { FullColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import { RowCenter } from '../../Header/Title/title.styles';


const EntityChoiceButtonGroupUnlinked = ({ onClick, entity, fcEmpresa, firstButtonCornerHelp }) => (
  <StyledRow customstyle={{ width: '100%', maxWidth: '100%' }}>

    <div className="entity-choice-pf-wrap">
      <StyledChoseEntityButton
        selected={entity === 'FISICA'}
        onClick={() => onClick('FISICA')}
        color="color_gray"
        borderColor="color_gray"
      >
        Pessoa Física
      </StyledChoseEntityButton>
      {firstButtonCornerHelp}
    </div>

    {fcEmpresa.length &&
      <StyledChoseEntityButton
        selected={entity === 'JURIDICA'}
        onClick={() => onClick('JURIDICA')}
        color="color_gray"
        borderColor="color_gray"
      >
        Pessoa Jurídica
      </StyledChoseEntityButton>
    || null}

  </StyledRow>
);

export default EntityChoiceButtonGroupUnlinked;
